// SCSS importeres IKKE her længere. defaults.js naas via bootPage, som er
// faelles for baade dashboard og marketing — derfor fik hver dashboard-bundle
// hele marketingtraeet med. Hver entry importerer nu sin egen indgang:
// marketing tager sass/main.scss, dashboardet tager sass/dashboard.scss.
import 'jquery';
import {Header} from "./layouts/header";
import {Faq} from "./layouts/faq";
import {lowerCaseEmail, onLoadCheckFancyboxMessage} from "./helpers/helpers";
import {toolTip} from "./components/tooltip";
import {validatePhone} from "./components/helpers";
import InitSplide from "./components/splide";
import InitHomepageModules from "./components/homepage-modules";
import InitProductDetails from "./components/product-details";
import toggleAccordions from "./components/accordions";
import tableOfContents from "./components/table_of_contents";
import videoLazyload from "./components/video-lazyload";
import utils from "./utils/utils";
import {registerLoaderGlobal} from "./helpers/loader";

export class Defaults {
    load() {
        // Setup global AJAX error handler for automatic nonce refresh on 403
        this.setupNonceRetry();
        registerLoaderGlobal();
        
        new Header();
        new Faq();
        new toolTip();
        onLoadCheckFancyboxMessage();
        InitSplide();
        InitHomepageModules();
        InitProductDetails();
        toggleAccordions();
        lowerCaseEmail();
        tableOfContents();
        videoLazyload();
    }
    
    setupNonceRetry() {
        // Track if we're already retrying to prevent infinite loops
        let isRetrying = false;
        
        $(document).ajaxError(async function(event, jqXHR, ajaxSettings, thrownError) {
            // Allow specific requests to opt-out (e.g. callers that implement their own retry)
            if (ajaxSettings && ajaxSettings.wl_skip_nonce_retry) {
                return;
            }
            // Only handle 403 errors that aren't already retries
            if (jqXHR.status === 403 && !isRetrying && ajaxSettings.url === utils.get_ajax_url()) {
                // WordPress check_ajax_referer() typically responds with body "-1" on nonce failure.
                const body = (typeof jqXHR.responseText === 'string') ? jqXHR.responseText.trim() : '';
                if (body !== '-1') {
                    return;
                }
                // Check if this request uses a nonce
                let hasNonce = false;
                if (typeof ajaxSettings.data === 'string') {
                    hasNonce = ajaxSettings.data.includes('_wpnonce=');
                } else if (ajaxSettings.data && typeof ajaxSettings.data === 'object') {
                    hasNonce = Object.prototype.hasOwnProperty.call(ajaxSettings.data, '_wpnonce');
                }
                
                if (hasNonce) {
                    isRetrying = true;
                    
                    try {
                        // Fetch fresh nonce
                        await utils.fetch_fresh_nonce();
                        
                        // Update the nonce in the request data
                        if (typeof ajaxSettings.data === 'string') {
                            // Parse the data string and update the nonce
                            const params = new URLSearchParams(ajaxSettings.data);
                            params.set('_wpnonce', utils.get_nonce());
                            ajaxSettings.data = params.toString();
                        } else if (typeof ajaxSettings.data === 'object') {
                            ajaxSettings.data._wpnonce = utils.get_nonce();
                        }
                        
                        // Retry the request
                        $.ajax(ajaxSettings);
                    } catch (error) {
                    } finally {
                        // Reset retry flag after a delay
                        setTimeout(() => { isRetrying = false; }, 1000);
                    }
                }
            }
        });
    }
}

export const defaults = new Defaults();
